<div class="main-content">
  <div class="container-fluid">
    <div class="card sq-card">          
      <div class="card-header card-header-squirrel">   
        <!-- <h4>{{this.translate.data['TENANTGROUPROLES'] | translate}}</h4>     -->
        <h4>Vorlagen Projektgruppenrollen</h4>    
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-8">
              <!-- <button matTooltip="{{this.translate.data['ADDTENANTGROUPROLE'] | translate}}"
               mat-button matSuffix mat-icon-button (click)="addTenantGroupRole()">
                  <mat-icon>add</mat-icon>
              </button> -->
              <a>
                <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 6px;margin-left: 5px" matTooltip="Neue Vorlage erfassen" (click)="addProjectGroupRole()">Neue Vorlage</button>
              </a>
              
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 tenant-grouproles-board-body-table">
              <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                  <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                  <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                      Squirrel's API rate limit has been reached. It will be reset in one minute.
                  </div>
              </div>
              <ag-grid-angular style="width:100%;  height: 100%; padding: 5px;" 
               class="ag-theme-balham"
               [overlayLoadingTemplate]="overlayLoadingTemplate"
               [gridOptions]="gridOptions" 
               (gridReady)="onGridReady($event)"
               [frameworkComponents]="frameworkComponents"
               [rowData]="rowData">
              </ag-grid-angular>
          </div>
        </div>          
      </div>
    </div>
  </div>
</div>
